import * as React from 'react';
import { Typography, TableContainer, TableRow, TableHead, TableCell, TableBody, Paper, Table, CircularProgress } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, IconButton } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box } from "@mui/material";
import { AppLayout } from "../../../layouts/app";
import { useContext, useEffect, useState } from "react";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { Link } from "react-router-dom";
import { FilesService } from "../../../services/files";
import { CrudLayout } from "../../../layouts/crud";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { DataGridFiles } from "../../../components/dataGridFiles";
import { SnackBar } from '../../../components/snackBar';
import { Button } from 'antd';
import { UploadOutlined, CloseOutlined } from '@ant-design/icons';

const columns = [
    {
        field: 'name',
        headerName: 'Nome do Arquivo',
        headerAlign: 'center',
        flex: 1,
        align: 'center',
        editable: false,
    },
    {
        field: 'version',
        headerName: 'Versão',
        headerAlign: 'center',
        flex: 1,
        editable: false,
        align: 'center',
    },
    {
        field: 'creationTime',
        headerName: 'Data do Upload',
        headerAlign: 'center',
        type: 'dateTime',
        valueFormatter: params => moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
        flex: 1,
        editable: false,
        align: 'center',
    },
];



export const Files = () => {
    const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
    const [loadingData, setLoadingData] = useState(false);
    const [loadingDataFiles, setLoadingDataFiles] = useState(false);
    const filesService = new FilesService();
    const [updateTrackerDialogOpen, setUpdateTrackerDialogOpen] = useState(false);
    const [file, setFile] = useState();
    const [files, setFiles] = useState([]);
    const [idFile, setIdFile] = useState();
    const [openSnackBar, setSnackBar] = useState(false);

    /**
     * Load that when the component is rendered
     */
    useEffect(() => {
        const breadcrumbs = [
            <Link key="1" to="/">
                Home
            </Link>,
            <Typography key="3" color="text.primary">
                Arquivos
            </Typography>
        ];
        setBreadcrumbs(breadcrumbs);
        getFiles();
    }, []);




    /**
     * Delete a specific tracker.
     * @param {id} File Id
     */
    const handleDelete = (id) => {
        filesService.deleteFile(id).then(res => {
            if (res.status === 200) {
                NotificationManager.success('Arquivo removido.', "", 3000);
            }
            getFiles();
            setIdFile(id);
            setSnackBar(true);
        }).catch(err => {
            NotificationManager.error('Erro ao remover arquivo.', "", 3000);
        });
    }


    const handleSendCommandTrackerClose = () => {
        setUpdateTrackerDialogOpen(false);
        setFile(null);
    }

    const getFiles = () => {
        filesService.getFilesAdm().then(res => {
            setFiles(res.data);
            setLoadingDataFiles(true);
        }).catch(err => {
            setLoadingDataFiles(true);
        });
    }

    const handleUpdateTrackerSave = () => {
        setLoadingData(true);
        filesService.saveFileFW(file).then(response => {
            if (response !== null) {
                NotificationManager.success('Arquivo salvo com sucesso!', "", 3000);
                getFiles();
                setUpdateTrackerDialogOpen(false);
                setLoadingData(false);
                setFile();
            } else {
                setUpdateTrackerDialogOpen(false);
                setLoadingData(false);
                NotificationManager.error('Error ao salvar arquivo', "", 3000);
            }

        })
            .catch(error => {
            });

    }

    const handleUpdateTrackerOpen = () => {
        setUpdateTrackerDialogOpen(true);

    }

    const handleCloseSnackBar = () => {
        setSnackBar(false);
    }

    const handleUndoOperation = () => {
        filesService.updateFile(idFile).then((res) => {
            setSnackBar(false);
            getFiles();
        }).catch((error) => {
        });

    }

    const action = (
        <React.Fragment>
            <Button style={{ backgroundColor: 'green', color: 'white', fontSize: '16px' }} size="medium" onClick={handleUndoOperation}  >
                Desfazer
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSnackBar}
            >
                <CloseRoundedIcon fontSize="small" sx={{ color: 'black' }} />
            </IconButton>
        </React.Fragment>
    );


    return (
        <>
            <AppLayout>
                <CrudLayout
                    title={
                        <>
                            Arquivos .hex
                        </>
                    }
                    children={
                        loadingDataFiles ?
                            <DataGridFiles
                                columns={columns}
                                editMode="row"
                                data={files}
                                deleteRecord={handleDelete}
                                updateTrackerDialogOpen={handleUpdateTrackerOpen}
                            />
                            :
                            <CircularProgress color="inherit" />
                    }
                />
                <div>
                    <Button onClick={handleUpdateTrackerOpen} icon={<UploadOutlined />} iconPosition={"end"} style={{ marginTop: "5px", background: "#008000", color: "white" }}>
                        Novo Arquivo
                    </Button>
                </div>
                <SnackBar side={"left"} open={openSnackBar} action={action} />

            </AppLayout>
            <Dialog open={updateTrackerDialogOpen} fullWidth={true} maxWidth={'sm'}>
                <DialogTitle>Adicionar arquivo hex</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Selecione o arquivo
                    </DialogContentText>
                    <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        <input accept="file/*" type="file" onChange={(e) => setFile(e.target.files[0])} />

                        {file &&
                            <Button size={"small"} icon={<CloseOutlined />} style={{ marginLeft: "10px", background: "#008000", color: "white" }} onClick={() => setFile(null)}>

                            </Button>
                        }
                        {file ? (
                            <TableContainer component={Paper}>
                                <Table aria-label="file-upload-fw">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">Nome do Arquivo</TableCell>
                                            <TableCell align="left">Tamanho (bytes)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow
                                            key={file.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {file.name}
                                            </TableCell>
                                            <TableCell align="right">{file.size}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : <></>}
                    </Box>
                    <DialogActions style={{ marginBottom: "-10px", padding: 0 }}>
                        <Button type={"primary"} style={{ background: "#D21717", color: "white", fontSize: '14px', marginTop: "5px", width: '80px' }} onClick={() => handleSendCommandTrackerClose()}>Cancelar</Button>
                        <Button type={"primary"} style={{ background: "#008000", color: "white", fontSize: '14px', marginTop: "5px", width: '80px' }} onClick={() => handleUpdateTrackerSave()} loading={loadingData} >Salvar</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    );
}